namespace RioERP.Orders {

    @Serenity.Decorators.registerClass()
    export class OrdersShippingExcelImportDialog extends Serenity.PropertyDialog<any, any> {
        protected getFormKey() { return "RioERP.OrdersShippingExcelImportForm" }
        //protected getIdProperty() { return StudentsRow.idProperty; }
        //protected getLocalTextPrefix() { return StudentsRow.localTextPrefix; }
        //protected getNameProperty() { return StudentsRow.nameProperty; }
        //protected getService() { return StudentsService.baseUrl; }

        protected form = new OrdersShippingExcelImportForm(this.idPrefix);

        constructor() {
            super();

            //if (!Authorization.hasPermission("Administration:Security") && Authorization.hasPermission("Workspace:Institute"))
            ////AssessmentPermissionKeys.Application + "|" + AssessmentPermissionKeys.Publisher
            //{

            //}
        }



        protected getDialogTitle(): string {
            return "Excel Import";
        }

        protected getDialogButtons(): Serenity.DialogButton[] {
            return [
                {
                    text: 'Import',
                    click: () => {
                        /debugger;/
                        if (!this.validateBeforeSave())
                            return;

                        if (this.form.FileName.value == null ||
                            Q.isEmptyOrNull(this.form.FileName.value.Filename)) {
                            Q.notifyError("Please select a file!");
                            return;
                        }

                        OrdersService.ExcelImportForShipping({
                            FileName: this.form.FileName.value.Filename,
                        }, response => {
                            Q.notifyInfo(
                                'Inserted: ' + (response.Inserted || 0));

                            if (response.ErrorList != null && response.ErrorList.length > 0) {
                                Q.notifyError(response.ErrorList.join(',\r\n '));
                            }

                            this.dialogClose();
                        });
                    },
                },
                {
                    text: 'Cancel',
                    click: () => this.dialogClose()
                }
            ];
        }

    }
}